import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<
	'pinnedItemRowOpenLabel' | 'pinnedItemRowStartChatLabel' | 'pinnedItemRowUnpinLabel',
	MessageDescriptor
> = defineMessages({
	pinnedItemRowOpenLabel: {
		id: 'rovo-pins.pinned-item-row.open-label',
		defaultMessage: 'Open',
		description: 'Accessible label for the action that navigates to a pinned item',
	},
	pinnedItemRowStartChatLabel: {
		id: 'rovo-pins.pinned-item-row.start-chat-label',
		defaultMessage: 'Start chat',
		description: 'Accessible label for the action that starts a Rovo chat about a pinned item',
	},
	pinnedItemRowUnpinLabel: {
		id: 'rovo-pins.pinned-item-row.unpin-label',
		defaultMessage: 'Unpin',
		description: 'Accessible label for the action that removes a pinned item from the list',
	},
});

export default messages;
